/*
$(".slick-slider").slick({
    // normal options...
    //infinite: true,
    slidesToShow: 4,
    //arrows: false,
    // the magic
    responsive: [{

        breakpoint: 1300,
        settings: {
            slidesToShow: 4,
            //infinite: true
        }

    }, {

        breakpoint: 800,
        settings: {
            slidesToShow: 2,
            //infinite: true
        }

    }, {

        breakpoint: 400,
        settings: {
            slidesToShow: 1,
            //infinite: true
        }

    }],
    nextArrow: '<div class="slider-btn slider-next "><span class="grand-icon icon-arrow"></span></div>',
    prevArrow: '<div class="slider-btn slider-prev "><span class="grand-icon icon-left-arrow"></span></div>'
});
*/
